// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2fS57";
export var logo = "footer-module--logo--2mBkW";
export var footerInfo = "footer-module--footer-info--29akF";
export var infoHeader = "footer-module--info-header--1mmLc";
export var contact = "footer-module--contact--16s89";
export var company = "footer-module--company--16a-F";
export var support = "footer-module--support--3WZHN";
export var copyright = "footer-module--copyright--hhCzN";